import React, { useState } from 'react';
import { generatePublicUrl } from '../../urlConfig';

function Thumbnail({ item, onOpen, disabled }) {
  const [failed, setFailed] = useState(false);
  const name = item.name || 'Позиция заказа';
  const label = `${name}${item.quantity != null ? ` · ${item.quantity} шт.` : ''}`;
  return <button type="button" className="orders-thumbnail" onClick={onOpen} disabled={disabled} title={label} aria-label={`Открыть заказ: ${label}`}>
    {item.image && !failed ? <img src={generatePublicUrl(item.image)} alt="" loading="lazy" decoding="async" onError={() => setFailed(true)} /> : <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      {item.type === 'work' ? <path d="m4 20 9-9m-2-6 3 3 3-3 3 3-3 3c1 4-4 7-7 4L4 21l-2-2 7-7C6 9 8 5 11 5Z" /> : <><rect x="3" y="3" width="18" height="18" rx="3" /><circle cx="8" cy="8" r="1.5" /><path d="m4 18 5-5 3 3 4-6 4 8" /></>}
    </svg>}
  </button>;
}

export default function OrderThumbnails({ order, onOpen, disabled }) {
  const previews = Array.isArray(order.itemPreviews) ? order.itemPreviews.slice(0, 4) : [];
  // Старый сервер может ещё не прислать поля превью во время обновления.
  if (!previews.length) return order.itemCount === 0 ? <span className="orders-thumbnails__empty">Без позиций</span> : null;
  const remaining = Math.max(0, Number(order.itemCount || previews.length) - previews.length);
  return <div className="orders-thumbnails" role="group" aria-label="Позиции заказа">
    {previews.map((item, index) => <Thumbnail key={`${item._id || index}:${item.image || ''}`} item={item} onOpen={onOpen} disabled={disabled} />)}
    {remaining > 0 && <button type="button" className="orders-thumbnail orders-thumbnail--more" onClick={onOpen} disabled={disabled} title={`Ещё ${remaining} позиций`} aria-label={`Открыть заказ: ещё ${remaining} позиций`}>+{remaining}</button>}
  </div>;
}
